define.alias("checkout/components/payment/tax-id", "calendar/components/payment/tax-id");